import React from 'react';
import { CustomizedButton } from '@components/Customized';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      textAlign: 'center',
      marginBottom: 40,
      '& button + button': {
        marginLeft: 10,
        [theme.breakpoints.down('xs')]: {
          marginLeft: 8
        }
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: 64
      }
    }
  };
});

interface Props {
  onClick: () => void;
}

const FooterBtnPresenter: React.FC<Props> = ({ onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CustomizedButton
        variant="outlined"
        size="medium"
        color="primary"
        onClick={onClick}
      >
        이전 단계
      </CustomizedButton>
      <CustomizedButton
        variant="contained"
        size="medium"
        color="primary"
        onClick={onClick}
      >
        작성 완료
      </CustomizedButton>
    </div>
  );
};

export default FooterBtnPresenter;
